<template>
  <q-btn class="badge-danger btn tw-document-trigger-btn" :disable="printBlocked" @click="toggleShowControls()" floating>
    <img src="@/assets/icons/editDoc.svg" alt="" />
    <q-tooltip>{{ printBlocked ? $t("order.tooltip.printOrderNotStarted") : $t("order.tooltip.print") }}</q-tooltip>
  </q-btn>
  <PrintDocumentDialog />
</template>

<script lang="ts">
import {Options, Vue} from "vue-class-component";
import store from "@/store";
import PrintDocumentDialog from "@/components/document/PrintDocumentDialog.vue";
import {isOrderNotStarted} from "@/commons/order-workflow";

@Options({
  components: { PrintDocumentDialog }
})
export default class PrintDocumentButton extends Vue {

  /** Commande non demarree : pas d'edition eflo (QR code sans tiroir). */
  get printBlocked() {
    return this.$route.name === 'order-edit' && isOrderNotStarted(store.state.orderModule.order)
  }

  toggleShowControls() {
    if (this.printBlocked) {
      return
    }
    return store.dispatch('printDocumentModule/toggleShow')
  }

}
</script>

<style scoped></style>
